import numeral from "numeral";
import qs from "qs";
import Highcharts from "highcharts/highstock";
import { Comparator } from "react-bootstrap-table2-filter";
import moment from "moment";

export function objectsToArray(objects) {
  let array = [];

  if (objects) {
    array = Object.keys(objects).map((key) => objects[key]);
  }

  return array;
}

export function toggleState(component, stateKey) {
  const newState = {};
  newState[stateKey] = !component.state[stateKey];
  component.setState(newState);
}

export function boolToString(booleanValue) {
  return booleanValue === true ? "Yes" : "No";
}

export function toNumber(value, format = "0,0[.]00") {
  if (value == 0) return 0;
  if (!value) return "N/A";
  return numeral(value).format(format);
}

export function toDecimalNumber(value, format = "0,0.0") {
  if (value == 0) {
    return numeral(value).format(format);
  }
  if (!value) return "N/A";
  return numeral(value).format(format);
}

export function toCurrency(amount, currency = "AUD", format = "0.0a") {
  const symbols = {
    AUD: "$",
    USD: "US$",
    NZD: "NZ$",
    EUR: "€",
    GBP: "£",
    CAN: "$",
    CAD: "CAN$",
  };
  if (!amount) return "-";
  if (amount < 0) {
    return "-" + symbols[currency] + numeral(Math.abs(amount)).format(format);
  } else {
    return symbols[currency] + numeral(amount).format(format);
  }
}

function isValidNumber(value) {
  if (typeof value === "number") {
    return !isNaN(value) && isFinite(value);
  }
  if (typeof value === "string" && value.trim() !== "") {
    return !isNaN(value) && isFinite(Number(value));
  }
  return false;
}

export function toCurrencyOrEmpty(amount, currency, format = "0.0a") {
  const symbols = {
    AUD: "$",
    USD: "US$",
    NZD: "NZ$",
    EUR: "€",
    GBP: "£",
    CAN: "$",
  };
  const resolvedCurrency = currency || "AUD";
  if (!isValidNumber(amount)) return "";
  return symbols[resolvedCurrency] + numeral(amount).format(format);
}

export function filterArrayObjects(arrayObjects, field, filterText) {
  return arrayObjects.filter((object) =>
    object[field].toLowerCase().includes(filterText.toLowerCase())
  );
}

// Returns an array of unique objects defined by the key from the array of duplicate objects
export function uniqueArrayObj(arrayObj, key) {
  return arrayObj.reduce(
    (prev, curr) =>
      prev.find((a) => a[key] === curr[key]) ? prev : prev.push(curr) && prev,
    []
  );
}

export function percentageNumber(value) {
  if (value == null) {
    return "-";
  } else {
    return value + "%";
  }
}

export function decimalToPercentage(value, wholeNumber = false) {
  if (value == null) {
    return "-";
  } else {
    if (wholeNumber) {
      return numeral(value * 100).format("0") + "%";
    } else {
      return numeral(value * 100).format("0.0") + "%";
    }
  }
}

export function simpleDecimalToPercentage(value, wholeNumber = false) {
  if (value == null) {
    return "N/A";
  } else {
    if (wholeNumber) {
      return numeral(value).format("0") + "%";
    } else {
      return numeral(value).format("0,0[.]0") + "%";
    }
  }
}

export function normalDecimalToPercentage(value, wholeNumber = false) {
  if (value == null) {
    return "N/A";
  } else {
    if (wholeNumber) {
      return numeral(value).format("0") + "%";
    } else {
      return numeral(value).format("0,0[.]0") + "%";
    }
  }
}

export function decimalNumberToPercentage(value, wholeNumber = false) {
  if (value == null) {
    return "N/A";
  }
  return numeral(value).format("0,0.0") + "%";
}

export function encodeParams(options = {}) {
  return qs.stringify(options, { arrayFormat: "brackets" });
}

export function buildFormData(formData, data, parentKey) {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    // const value = data == null ? '' : data;

    if (data) formData.append(parentKey, data);
  }
}

export function capitalize(string) {
  const text = string || "";
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function sortByDate(a, b, order, dataField) {
  if (order === "asc") {
    return new Date(b) - new Date(a);
  }

  return new Date(a) - new Date(b);
}

export function bookmarkPriorityOptions() {
  return [
    { label: "Interesting", value: "interesting" },
    { label: "High", value: "high" },
    { label: "Meets Needs", value: "meets_needs" },
    { label: "Probable", value: "probable" },
  ].map((opt, index) => {
    return (
      <option key={index} value={opt.value}>
        {opt.label}
      </option>
    );
  });
}

export function graphColors() {
  const colors = Highcharts.getOptions().colors;
  const openDirectorColors = [
    "#001F38",
    "#71C6CC",
    "#1E6685",
    "#AF6A3A",
    "#EDECE6",
    "#353535",
  ];

  const difference = colors.filter(
    (color) => !openDirectorColors.includes(color)
  );
  return openDirectorColors.concat(difference);
}

export function titleCase(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

export function printReport(
  templateId,
  download_name,
  data,
  startPrint,
  donePrint,
  _email
) {
  const url = `/api/v1/js_report`;
  startPrint(() => {
    toastr["success"]("Print Scheduled. You will receive an email");
    const request = {
      js_report: {
        results: data,
        file_name: download_name,
        short_id: templateId,
      },
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify(request),
    })
      .then((response) => response.text())
      .then((html) => {
        donePrint();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
}

export function compToRansack(comparator) {
  let comp = null;
  if (comparator === Comparator.EQ) {
    comp = "eq";
  } else if (comparator === Comparator.NE) {
    comp = "not_eq";
  } else if (comparator === Comparator.GT) {
    comp = "gt";
  } else if (comparator === Comparator.GE) {
    comp = "gteq";
  } else if (comparator === Comparator.LT) {
    comp = "lt";
  } else if (comparator === Comparator.LE) {
    comp = "lteq";
  }
  return comp;
}

export function checkScrollBar(element, dir) {
  dir = dir === "vertical" ? "scrollTop" : "scrollLeft";

  let res = !!element[dir];

  if (!res) {
    element[dir] = 1;
    res = !!element[dir];
    element[dir] = 0;
  }
  return res;
}

export function cleanCurrencyValue(value, decimalLimit) {
  const withoutPrefix = value.replace("$", "");
  const withoutCommas = withoutPrefix.replace(/,/g, "");
  if (withoutCommas.includes(".")) {
    const [int, decimals] = withoutCommas.split(".");
    //.slice(0, decimalLimit) this is already handled by mask
    return `${int}.${decimals}`;
  }
  return withoutCommas;
}

export function memberDirectorSectorOptions() {
  return [
    { value: "all", title: "All" },
    { value: "banking", title: "Banking and Finance" },
    { value: "consumer", title: "Consumer - Retail" },
    { value: "energy", title: "Energy" },
    { value: "health", title: "HealthCare" },
    { value: "industrial", title: "Industrial" },
    { value: "mining", title: "Mining - Materials" },
    { value: "property", title: "Real Estate / Property" },
    { value: "technology", title: "Technology/Communications" },
  ];
}

export function memberDirectorLocationOptions(all = false) {
  const values = [
    { value: "ACT", title: "ACT" },
    { value: "NSW", title: "NSW" },
    { value: "QLD", title: "QLD" },
    { value: "SA", title: "SA" },
    { value: "TAS", title: "TAS" },
    { value: "VIC", title: "VIC" },
    { value: "WA", title: "WA" },
  ];
  const extras = [
    { value: "aus_locations", title: "Anywhere in Australia / New Zealand" },
    { value: "any_locations", title: "Anywhere" },
  ];
  return all ? [...values, ...extras] : values;
}

export function capitalizeText(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalizeWords(sentence) {
  return sentence.replace(/(\S+)([\s-])?/g, (match, word, separator) => {
    const capitalizedWord =
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    return capitalizedWord + (separator || "");
  });
}

export function isCurrentEndDate(date) {
  if (date) {
    return moment(date).isSameOrAfter(moment());
  } else {
    return true;
  }
}

export function isPastEndDate(date) {
  return !isCurrentEndDate(date);
}

export function diff(source, target) {
  return target - source;
}

export function sortArrayByField(array, field) {
  // Create a deep copy of the array to avoid mutating the original
  const arrayCopy = structuredClone(array);

  // Sort the array alphabetically based on the specified field
  arrayCopy.sort((a, b) => {
    const fieldA = a[field]?.toString().toLowerCase() || "";
    const fieldB = b[field]?.toString().toLowerCase() || "";

    if (fieldA < fieldB) return -1;
    if (fieldA > fieldB) return 1;
    return 0;
  });

  return arrayCopy;
}

export const sortByEntityTypeAndName = (array) => {
  return array.sort((a, b) => {
    const getPriority = (item) => {
      if (item.path === "companies") return 0;
      if (item.path === "private-companies-with-executives") return 1;
      if (item.path === "governments-with-executives") return 2;
      if (item.path === "superannuations") return 3;
      if (item.path === "nfps") return 4;
      return 5;
    };

    const priorityA = getPriority(a);
    const priorityB = getPriority(b);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    return (a.name || "").localeCompare(b.name || "");
  });
};

export function extractYearFromReportDate(reportDate) {
  if (!reportDate) return null;
  try {
    return new Date(reportDate).getFullYear();
  } catch (error) {
    console.warn("Invalid report_date format:", reportDate);
    return null;
  }
}
